import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { auth } from '../../services/firebase';
import { getFunctions, httpsCallable } from 'firebase/functions';

const ProfileSettings = () => {
  const navigate = useNavigate();
  const [user, setUser] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [message, setMessage] = useState('');

  useEffect(() => {
    const unsubscribe = auth.onAuthStateChanged((currentUser) => {
      if (currentUser) {
        setUser(currentUser);
      } else {
        navigate('/login');
      }
    });

    return () => unsubscribe();
  }, [navigate]);

  const handleUpgradeToFoundingMember = async () => {
    setIsLoading(true);
    setMessage('');

    try {
      const functions = getFunctions();
      const createCheckoutSession = httpsCallable(functions, 'createCheckoutSession');
      
      const result = await createCheckoutSession({});
      
      // Redirect to Stripe checkout
      window.location.href = result.data.checkoutUrl;
      
    } catch (error) {
      console.error('Error creating checkout session:', error);
      setMessage('❌ Error creating checkout session. Please try again.');
      setIsLoading(false);
    }
  };

  if (!user) {
    return <div style={{ padding: '1.36rem', textAlign: 'center' }}>Loading...</div>;
  }

  return (
    <div style={{
      maxWidth: '544px',
      margin: '1.36rem auto',
      padding: '1.36rem',
      backgroundColor: 'white',
      borderRadius: '8.16px',
      boxShadow: '0 2.72px 8.16px rgba(0, 0, 0, 0.08)'
    }}>
      <h1 style={{ marginBottom: '1.36rem', color: '#333' }}>Profile Settings</h1>

      {/* Account Information */}
      <section style={{ marginBottom: '2.04rem' }}>
        <h2 style={{ marginBottom: '0.68rem', color: '#555' }}>Account Information</h2>
        <div style={{ 
          padding: '1.02rem', 
          backgroundColor: '#f8f9fa', 
          borderRadius: '5.44px',
          marginBottom: '0.68rem'
        }}>
          <div style={{ marginBottom: '0.68rem' }}>
            <strong>Email:</strong> {user.email}
          </div>
          <div style={{ marginBottom: '0.68rem' }}>
            <strong>Account Created:</strong> {new Date(user.metadata.creationTime).toLocaleDateString()}
          </div>
          <div>
            <strong>Last Sign In:</strong> {new Date(user.metadata.lastSignInTime).toLocaleDateString()}
          </div>
        </div>
      </section>

      {/* Membership Section */}
      <section style={{ marginBottom: '2.04rem' }}>
        <h2 style={{ marginBottom: '0.68rem', color: '#555' }}>Membership</h2>
        
        <div style={{
          border: '1.36px solid #007bff',
          borderRadius: '8.16px',
          padding: '1.36rem',
          backgroundColor: '#f8f9ff'
        }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <div>
              <h3 style={{ margin: '0 0 0.34rem 0', color: '#007bff' }}>
                🌟 Founding Member
              </h3>
              <p style={{ margin: '0 0 0.68rem 0', color: '#666' }}>
                Support Artifex's development and get exclusive benefits
              </p>
              
              <ul style={{ margin: '0 0 0.68rem 0', paddingLeft: '1.02rem', color: '#666' }}>
                <li>Permanent founding member badge</li>
                <li>Advanced Digital Card features</li>
                <li>Early access to new features</li>
                <li>Up to 3 custom links on cards</li>
                <li>Priority support</li>
              </ul>
              
              <div style={{ 
                fontSize: '1.02rem', 
                fontWeight: 'bold', 
                color: '#007bff',
                marginBottom: '0.68rem'
              }}>
                $99 <span style={{ fontSize: '0.68rem', fontWeight: 'normal' }}>lifetime</span>
              </div>
            </div>
            
            <button
              onClick={handleUpgradeToFoundingMember}
              disabled={isLoading}
              style={{
                padding: '0.68rem 1.36rem',
                backgroundColor: isLoading ? '#ccc' : '#007bff',
                color: 'white',
                border: 'none',
                borderRadius: '5.44px',
                fontSize: '0.748rem',
                fontWeight: '600',
                cursor: isLoading ? 'not-allowed' : 'pointer',
                transition: 'background-color 0.2s'
              }}
            >
              {isLoading ? 'Processing...' : 'Become a Founding Member'}
            </button>
          </div>
        </div>
      </section>

      {/* Digital Card Settings */}
      <section style={{ marginBottom: '2.04rem' }}>
        <h2 style={{ marginBottom: '0.68rem', color: '#555' }}>Digital Card</h2>
        <div style={{ 
          padding: '1.02rem', 
          backgroundColor: '#f8f9fa', 
          borderRadius: '5.44px',
          marginBottom: '0.68rem'
        }}>
          <button
            onClick={() => navigate('/card-generator')}
            style={{
              padding: '0.51rem 1.02rem',
              backgroundColor: '#28a745',
              color: 'white',
              border: 'none',
              borderRadius: '4.08px',
              cursor: 'pointer',
              marginRight: '0.68rem'
            }}
          >
            Edit Digital Card
          </button>
          
          <button
            onClick={() => navigate('/card-settings')}
            style={{
              padding: '0.51rem 1.02rem',
              backgroundColor: '#6c757d',
              color: 'white',
              border: 'none',
              borderRadius: '4.08px',
              cursor: 'pointer'
            }}
          >
            Card Preferences
          </button>
        </div>
      </section>

      {/* Status Message */}
      {message && (
        <div style={{
          padding: '0.68rem',
          backgroundColor: message.includes('❌') ? '#fee' : '#efe',
          color: message.includes('❌') ? '#c33' : '#363',
          borderRadius: '4.08px',
          fontSize: '0.612rem',
          marginTop: '0.68rem'
        }}>
          {message}
        </div>
      )}
    </div>
  );
};

export default ProfileSettings;